export default [
     {
        path: "/events-calendar",
        name: "events-calendar",
        component: () => import('./EventsCalendar.vue') 
    },
]